/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, November 22nd 2021, 7:23:57 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
import { APIMany2OneSelectFormInput, ConcreteAPIMany2OneSelectFormInputProps } from "ui-widgets";
import { Sector } from "lib/schemas";
import { APISERVICEPATHS } from "lib/api";
import BusinessIcon from "@mui/icons-material/Business";

export const IndustryPickerInput = <T,>(props: ConcreteAPIMany2OneSelectFormInputProps<T, Sector>) => {
  return (
    <APIMany2OneSelectFormInput<T, Sector>
      label="Select Your Industry"
      itemIdProperty="id"
      getOptionLabel={(option) => `${option.name} (${option.isic_code})`}
      loadingText="Loading Sectors"
      apiServicePath={APISERVICEPATHS.sectors}
      inputStartAdornment={<BusinessIcon color="primary" />}
      {...props}
    />
  );
};
